import { ApiError } from '../types/apiError'

/**
 * Tradução dos nomes de campo da API para os nomes usados no formulário.
 *
 * A API valida em português e com a estrutura do payload de compra
 * (`endereco.cep`); o formulário usa nomes próprios em `FormFields`. Sem este
 * mapa, o `errors` do 422 não teria como marcar o campo certo.
 */
const CAMPO_API_PARA_FORM: Record<string, string> = {
  nome: 'name',
  email: 'email',
  telefone: 'telephone',
  data_nascimento: 'date',
  documento: 'cpfCnpj',
  cpf: 'cpfCnpj',
  cnpj: 'cpfCnpj',
  cep: 'cep',
  rua: 'street',
  numero: 'number',
  complemento: 'complement',
  bairro: 'neighborhood',
  id_cidade: 'city',
  'endereco.cep': 'cep',
  'endereco.rua': 'street',
  'endereco.numero': 'number',
  'endereco.complemento': 'complement',
  'endereco.bairro': 'neighborhood',
  'endereco.id_cidade': 'city'
}

export interface CamposTraduzidos {
  /** Erros já associados a um campo do formulário. */
  fieldErrors: Record<string, string[]>
  /**
   * Mensagens de campos que o mapa não conhece. Nunca são descartadas: o
   * chamador as exibe no aviso geral, senão um campo novo da API sumiria em
   * silêncio.
   */
  semCampo: string[]
}

export function traduzirCampos(fields?: Record<string, string[]>): CamposTraduzidos {
  const fieldErrors: Record<string, string[]> = {}
  const semCampo: string[] = []

  for (const [campoApi, mensagens] of Object.entries(fields ?? {})) {
    const campoForm = CAMPO_API_PARA_FORM[campoApi]

    if (campoForm) {
      fieldErrors[campoForm] = (fieldErrors[campoForm] ?? []).concat(mensagens)
    } else {
      semCampo.push(...mensagens)
    }
  }

  return { fieldErrors, semCampo }
}

/**
 * Monta a mensagem do aviso geral a partir de um ApiError de validação,
 * anexando o que não coube em nenhum campo.
 */
export function mensagemComCamposSoltos(mensagemBase: string, erro: ApiError): string {
  const { semCampo } = traduzirCampos(erro.fields)

  return semCampo.length ? `${mensagemBase} ${semCampo.join(' ')}` : mensagemBase
}
